import { DISTRIBUTION_MODES } from '.';
import {
  TEAM,
  ROLE_LIST,
  MEMBER_LIST,
  REPORTS,
  TRANSACTION,
  TIMECARDS,
  SETTING,
  ACCOUNT,
  MENU,
  MENU_AVAILABILITY,
  ROLE_CREATE,
  ROLE_EDIT,
  DEVICE_LIST,
  DEVICE,
  HOME,
  FLOOR_PLAN,
  ADJUSTMENT,
  DISCOUNT,
  FEE,
  MENU_PREFERENCES,
  MENU_SETUP,
  MENU_CUSTOMIZATIONS,
  SETTING_GENERAL,
  SETTING_QRCODE_ORDERING,
  SETTING_WAITLIST,
  SETTING_RESERVATION,
  REPORTS_SALES,
  REPORTS_PAYOUT_FEE,
  WORKFORCE,
  MENU_PRICE_EDITOR,
  LOYALTY_REPORTS,
  LOYALTY_MEMBERS,
  LOYALTY_TRANSACTIONS,
  LOYALTY_SETTINGS,
  LOYALTY_POINTS,
  LOYALTY_POINTS_REPORTS,
  REPORTS_MONTHLY,
  REPORTS_VOIDED_ITEMS,
  REPORTS_CASH,
  SETTING_SERVICE,
  CATEGORY,
  SETTING_TIPS,
  SETTING_PRINTOUTS,
  REPORTS_PAYOUT,
  DEPARTMENT_LIST,
  REPORTS_GIFT_CARD,
  ROLES_AND_MEMBERS,
  LOYALTY,
  WORKFORCE_LABOR_SUMMARY,
  WORKFORCE_PRODUCTIVITY,
  WORKFORCE_TIME_LOG,
  TIPS_MANAGEMENT,
  CREATE_TIPS_SHEET,
  LOYALTY_AUTOPOLIT,
  LOYALTY_MANUAL_CAMPAIGN,
  MENU_PRINTER_MAPPING,
  BREAK_MANAGEMENT,
  SETTING_REPORTS,
  PROMOTIONS,
  ORDERS_AND_SHOPPING,
} from './permissionCodes';
import {
  PageAccount,
  PageAdjustment,
  PageCashReport,
  PageDashboard,
  PageDevice,
  PageDeviceAll,
  PageDiscount,
  PageFee,
  PageFloorPlan,
  PageGeneralSettings,
  PageLoyaltyMembers,
  PageLoyaltyTranscations,
  PageLoyaltyOverview,
  PageLoyaltySettings,
  PageLoyaltyPointsReport,
  PageLoyaltyPointsSettings,
  PageLoyaltyAutopilot,
  PageLoyaltyManualCampaign,
  PageMenuManagement,
  PageMenuManagementForAvailability,
  PageMenuManagementForCustomizations,
  PageMenuManagementForDishPreference,
  PageMenuManagementForMenus,
  PageMenuManagementForPriceEditor,
  PageMonthlyStatement,
  PageOrders,
  PageWorkforce,
  PageQRCodeSettings,
  PageWaitListSettings,
  PageReservationSettings,
  PageReport,
  PageRoleAdd,
  PageRoleEdit,
  PageSalesReport,
  PageSettings,
  PageTeam,
  PageTeamMembers,
  PageTeamRoles,
  PageTimecards,
  PageTransaction,
  PageWorkflowSettings,
  PageMenuManagementForCategories,
  PageTipsSettings,
  PagePrintoutsSettings,
  PagePayoutReport,
  PagePayoutFeeReport,
  PageTeamDepartment,
  PageGiftCard,
  PageTeamRolesAndMembers,
  PageLoyalty,
  PageWorkforceLaborSummary,
  PageWorkforceProductivity,
  PageWorkforceTimeLog,
  PageTipsAllocation,
  PageWorkforceTipSummary,
  PageUserActivities,
  PageMenuManagementPrinterMapping,
  PageTeamBreaks,
  PageReportsSettings,
  PagePromotions,
} from './routes';

// permission route mapping
export default {
  [ROLES_AND_MEMBERS]: {
    path: PageTeamRolesAndMembers,
    showInMenu: true,
  },
  [ROLE_LIST]: {
    path: PageTeamRoles,
    showInMenu: false,
  },
  [MEMBER_LIST]: {
    path: PageTeamMembers,
    showInMenu: false,
  },
  [DEPARTMENT_LIST]: {
    path: PageTeamDepartment,
    showInMenu: false,
  },
  [BREAK_MANAGEMENT]: {
    path: PageTeamBreaks,
    showInMenu: true,
  },
  [TEAM]: {
    path: PageTeam,
    icon: 'team',
    showInMenu: true,
  },
  [REPORTS_SALES]: {
    path: PageSalesReport,
    showInMenu: true,
  },
  [REPORTS_PAYOUT]: {
    path: PagePayoutReport,
    showInMenu: true,
  },
  [REPORTS_PAYOUT_FEE]: {
    path: PagePayoutFeeReport,
    showInMenu: true,
  },
  [WORKFORCE_PRODUCTIVITY]: {
    path: PageWorkforceProductivity,
    showInMenu: false,
  },
  [WORKFORCE_TIME_LOG]: {
    path: PageWorkforceTimeLog,
    showInMenu: false,
  },
  [WORKFORCE_LABOR_SUMMARY]: {
    path: PageWorkforceLaborSummary,
    showInMenu: false,
  },
  [WORKFORCE]: {
    path: PageWorkforce,
    showInMenu: true,
  },
  [REPORTS_MONTHLY]: {
    path: PageMonthlyStatement,
    showInMenu: true,
  },
  [REPORTS_CASH]: {
    path: PageCashReport,
    showInMenu: true,
  },
  [REPORTS_VOIDED_ITEMS]: {
    path: PageUserActivities,
    showInMenu: false,
  },
  [REPORTS_GIFT_CARD]: {
    path: PageGiftCard,
    showInMenu: true,
  },
  [REPORTS]: {
    path: PageReport,
    icon: 'dashboard',
    showInMenu: true,
  },
  [TRANSACTION]: {
    path: PageTransaction,
    icon: 'transaction',
    showInMenu: true,
  },
  [TIMECARDS]: {
    path: PageTimecards,
    icon: 'calendar',
    showInMenu: true,
  },
  [ACCOUNT]: {
    path: PageAccount,
    icon: 'user',
    showInMenu: true,
  },
  [SETTING_GENERAL]: {
    path: PageGeneralSettings,
    showInMenu: true,
  },
  [SETTING_QRCODE_ORDERING]: {
    path: PageQRCodeSettings,
    showInMenu: true,
  },
  [SETTING_SERVICE]: {
    path: PageWorkflowSettings,
    showInMenu: true,
  },
  [SETTING_TIPS]: {
    path: PageTipsSettings,
    showInMenu: true,
  },
  [SETTING_PRINTOUTS]: {
    path: PagePrintoutsSettings,
    showInMenu: true,
  },
  [SETTING_REPORTS]: {
    path: PageReportsSettings,
    showInMenu: true,
  },
  [SETTING]: {
    path: PageSettings,
    icon: 'setting',
    showInMenu: true,
  },
  [MENU_AVAILABILITY]: {
    path: PageMenuManagementForAvailability,
    showInMenu: true,
  },
  [CATEGORY]: {
    path: PageMenuManagementForCategories,
    showInMenu: true,
  },
  [MENU_PRICE_EDITOR]: {
    path: PageMenuManagementForPriceEditor,
    showInMenu: true,
  },
  [MENU_PREFERENCES]: {
    path: PageMenuManagementForDishPreference,
    showInMenu: true,
  },
  [MENU_SETUP]: {
    path: PageMenuManagementForMenus,
    showInMenu: true,
  },
  [MENU_CUSTOMIZATIONS]: {
    path: PageMenuManagementForCustomizations,
    showInMenu: true,
  },
  [MENU_PRINTER_MAPPING]: {
    path: PageMenuManagementPrinterMapping,
    showInMenu: true,
  },
  [MENU]: {
    path: PageMenuManagement,
    icon: 'profile',
    showInMenu: true,
  },
  [ROLE_CREATE]: {
    path: PageRoleAdd,
    showInMenu: false,
  },
  [ROLE_EDIT]: {
    path: PageRoleEdit,
    showInMenu: false,
  },
  [DEVICE]: {
    path: PageDevice,
    icon: 'desktop',
    showInMenu: true,
  },
  [DEVICE_LIST]: {
    path: PageDeviceAll,
    showInMenu: false,
  },
  [DISCOUNT]: {
    path: PageDiscount,
    showInMenu: false,
  },
  [FEE]: {
    path: PageFee,
    showInMenu: false,
  },
  [ADJUSTMENT]: {
    path: PageAdjustment,
    icon: 'money-collect',
    showInMenu: true,
  },
  [ORDERS_AND_SHOPPING]: {
    path: PageOrders,
    icon: 'shopping',
    showInMenu: true,
  },
  [HOME]: {
    icon: 'home',
    path: PageDashboard,
    showInMenu: true,
  },
  [FLOOR_PLAN]: {
    icon: 'layout',
    path: PageFloorPlan,
    showInMenu: true,
  },
  [LOYALTY]: {
    icon: 'apartment',
    path: PageLoyalty,
    showInMenu: true,
    distributionMode: DISTRIBUTION_MODES.LOYALTY,
  },
  [LOYALTY_REPORTS]: {
    path: PageLoyaltyOverview,
    showInMenu: true,
    distributionMode: DISTRIBUTION_MODES.LOYALTY,
  },
  [LOYALTY_MEMBERS]: {
    path: PageLoyaltyMembers,
    showInMenu: true,
    distributionMode: DISTRIBUTION_MODES.LOYALTY,
  },
  [LOYALTY_TRANSACTIONS]: {
    path: PageLoyaltyTranscations,
    showInMenu: true,
    distributionMode: DISTRIBUTION_MODES.LOYALTY,
  },
  [LOYALTY_SETTINGS]: {
    path: PageLoyaltySettings,
    showInMenu: true,
    distributionMode: DISTRIBUTION_MODES.LOYALTY,
  },
  [LOYALTY_POINTS]: {
    path: PageLoyaltyPointsSettings,
    showInMenu: true,
    distributionMode: DISTRIBUTION_MODES.LOYALTY,
  },
  [LOYALTY_POINTS_REPORTS]: {
    path: PageLoyaltyPointsReport,
    showInMenu: true,
    distributionMode: DISTRIBUTION_MODES.LOYALTY,
  },
  [LOYALTY_AUTOPOLIT]: {
    path: PageLoyaltyAutopilot,
    showInMenu: true,
    distributionMode: DISTRIBUTION_MODES.LOYALTY_CRM,
  },
  [LOYALTY_MANUAL_CAMPAIGN]: {
    path: PageLoyaltyManualCampaign,
    showInMenu: true,
    distributionMode: DISTRIBUTION_MODES.LOYALTY_CRM,
  },
  [TIPS_MANAGEMENT]: {
    path: PageTipsAllocation,
    showInMenu: true,
  },
  [CREATE_TIPS_SHEET]: {
    path: PageWorkforceTipSummary,
    showInMenu: false,
  },
  [SETTING_WAITLIST]: {
    path: PageWaitListSettings,
    showInMenu: true,
    distributionMode: DISTRIBUTION_MODES.WAIT_LIST,
  },
  [SETTING_RESERVATION]: {
    path: PageReservationSettings,
    showInMenu: true,
    distributionMode: DISTRIBUTION_MODES.RESERVATION,
  },
  [PROMOTIONS]: {
    icon: 'gift',
    path: PagePromotions,
    showInMenu: true,
    distributionMode: DISTRIBUTION_MODES.PROMOTION,
  },
};
